
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppInput from '@/components/AppInput.vue'
import { partnerEntity } from '@/models/models'
import CommonForm from '@/mixins/CommonForm'
import { cloneDeep } from 'lodash'

@Component({
    components: {
        AppInput,
    },
})

export default class PartnerFormContactsData extends CommonForm {
    @Prop() public value?: PartnerEntity

    get partner(): PartnerEntity {
        return this.value ?? partnerEntity
    }

    get typeContactOptions(): InputSelectOptionEntity[] {
        return [
            { value: 'EMAIL', text: 'Email' },
            { value: 'PHONE', text: 'Telefone' },
        ]
    }
}
